// eslint-disable-next-line max-classes-per-file
export class CurrentDate {
  static readonly type = '[Date] current date';
  constructor(public payload: Date) {}
}

export class UpdateSelectedDate {
  static readonly type = '[Date] select new Data';
  constructor(public payload: string) {}
}

export class UpdateShowToggle {
  static readonly type = '[Date] update show toggle';
  constructor(public payload: boolean) {}
}
